import { render, staticRenderFns } from "./SnackbarCollection.vue?vue&type=template&id=108688d1&scoped=true"
import script from "./SnackbarCollection.vue?vue&type=script&lang=js"
export * from "./SnackbarCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108688d1",
  null
  
)

export default component.exports